const angular = require('angular');

const { SavedCardService } = require('./saved-card.service');
const { saveCardComponentDefinition } = require('./save-card.component');

angular.module('wowApp.shop')
    .service('SavedCardService', ['Restangular', SavedCardService])
    .component('wowSaveCard', saveCardComponentDefinition);



// WEBPACK FOOTER //
// ./src/order/savedcard/index.js